import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  ModernBorderRadius,
  useDiscoverTheme,
} from '../../../../common/emotion';

export const ColorGroupWrapper = styled.div(() => {
  const {
    colors: { BorderColor, ContentBackground, ColorGroupDragPreview },
  } = useDiscoverTheme();

  return css`
    border: 1px solid ${BorderColor};
    border-radius: ${ModernBorderRadius};
    padding: 10px;
    margin-bottom: 10px;
    background-color: ${ContentBackground};
    &.drop-valid,
    &.dragging {
      > div {
        opacity: 0;
      }
      border-style: dashed;
      background-color: ${ColorGroupDragPreview};
    }
  `;
});

export const ColorGroupInput = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ColorGroupFieldsLabel = styled.div`
  width: 30%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 200;
  font-style: inherit;
  font-size: 12px;
`;

export const ColorGroupFields = styled.div`
  display: flex;
  align-items: center;
`;

export const DragIcon = styled.div(() => {
  const {
    colors: { DefaultIconColor },
  } = useDiscoverTheme();

  return css`
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: move;
    }

    svg {
      width: 12px;
      height: 12px;
      fill: ${DefaultIconColor};
    }
  `;
});
